import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../lib/api";

export const TicketDownload = ({ booking, className = "" }) => {
  const [busy, setBusy] = useState(false);
  if (!booking.ticket_file || booking.status === "cancelled") return null;
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await http.get(`/bookings/${booking.booking_id}/ticket-file`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url; a.download = booking.ticket_file.filename || `${booking.booking_id}-eticket`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) { toast.error(errMsg(e, "Could not download e-ticket")); }
    setBusy(false);
  };
  return (
    <button onClick={download} disabled={busy} data-testid={`download-ticket-${booking.booking_id}`}
      className={`flex items-center gap-2 rounded-full bg-[#0F9D58] hover:bg-[#0b8a4c] text-white px-4 py-2 text-sm font-semibold transition-colors ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} E-ticket
    </button>
  );
};

export const TicketUpload = ({ booking, onDone }) => {
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("File must be under 10 MB");
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      await http.post(`/admin/bookings/${booking.booking_id}/ticket-file`, fd);
      toast.success("E-ticket uploaded. The customer can download it now.");
      onDone();
    } catch (e) { toast.error(errMsg(e, "Upload failed")); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="ticket-upload">
      <label className={`rounded-full border border-dashed border-slate-400 px-4 py-2 text-sm font-semibold cursor-pointer hover:border-[#EC5B24] ${busy ? "opacity-50 pointer-events-none" : ""}`}>
        {busy ? <Loader2 className="inline h-4 w-4 animate-spin mr-1" /> : null}
        {booking.ticket_file ? "Replace e-ticket file" : "Upload e-ticket (PDF / JPG / PNG)"}
        <input type="file" accept="application/pdf,image/jpeg,image/png" className="hidden" data-testid="ticket-file-input"
          onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} />
      </label>
      {booking.ticket_file && <span className="text-xs text-slate-500" data-testid="ticket-file-name">Current: {booking.ticket_file.filename}</span>}
      {booking.ticket_file && <TicketDownload booking={booking} />}
    </div>
  );
};
